import isDebug from '../../isDebug/index.js';
import isTest from '../../isTest/index.js';
export default (level, message, ...objs) => {
    if (!isDebug || isTest) {
        return;
    }
    console[level](`[${level}] ${message}`, ...objs); // eslint-disable-line no-console
};
//# sourceMappingURL=index.js.map